import { DefaultServiceAction } from 'store/_utils/_Generic/actions';
import { GenericServiceReducer } from 'store/_utils/_Generic/reducer';

import type { Reducer } from 'redux';
export default class ActionType {
  name: string;
  action: Function;
  reducer: Reducer<any>;
  request: string;
  success: string;
  error: string;
  reset: string;

  constructor(name: string, action: Function = DefaultServiceAction, reducer: any = GenericServiceReducer) {
    this.name = name;
    this.action = action;
    this.reducer = (state: any, action: any) => reducer(name, { isFetching: false })(state, action);
    this.request = `@@service/${name}_REQUEST`;
    this.success = `@@service/${name}_SUCCESS`;
    this.error = `@@service/${name}_ERROR`;
    this.reset = `@@service/${name}_RESET`;
  }

  getReducer() {
    return this.reducer;
  }

  getAction() {
    return this.action;
  }

  createAction(service?: Function, customAction?: Function) {
    return this.action && service ? this.action(service, this.name) : customAction(this);
  }

  createReducer(reducer: any, initialState: any = { isFetching: false }) {
    return (state: any, action: any) => reducer(this.name, initialState, this.request, this.success, this.error, this.reset)(state, action);
  }
}
